<!--
 * @Author: jzh
 * @Date: 2020-03-18 17:08:54
 * @LastEditors: zxf
 * @LastEditTime: 2023-03-06 11:14:23
 * @Description: 关联权限部门，单身份关联权限部门
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="数据权限配置"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <!--用户基本信息-->
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户代码"
              prop="userCode"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.userCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户名称"
              prop="userName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.userName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.deptName }}
              </span>
            </el-form-item>
          </el-col>
          <!--用户权限部门树-->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-tree
              ref="tree"
              class="c-form__tree o-tree-overflow--unset"
              style="height: 278px;overflow: auto;"
              node-key="nodeCode"
              show-checkbox
              :data="fd.allDeptTreeList"
              :props="defaultProps"
              :check-strictly="checkStrictly"
              :default-expanded-keys="fd.permissionDeptTreeList"
              :default-checked-keys="fd.permissionDeptTreeList"
              @check-change="handleCheckChange"
            />
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { allDeptTree, permissionDeptTree, savePermission } from '../user.service';

export default {
  name: 'SingleRelatePermissionDept',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        userVO: {
          userCode: null, // 用户信息
          userName: null, // 用户名称
          deptName: null // 所属部门名称
        },

        allDeptTreeList: [], // 部门树数组
        permissionDeptTreeList: [] // 权限部门数组
      },
      /* 表单参数 End */

      permissionArr: [], // 选中的权限部门数组

      /* 树组件配置 Start */
      // 树组件默认参数配置
      defaultProps: {
        key: 'nodeCode',
        children: 'childNodes',
        label: 'nodeName'
      },

      checkStrictly: true // 树结构多选框勾选时不自动关联父元素
      /* 树组件配置 End */
    };
  },
  methods: {
    /**
     * @description: 初始化机构部门树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      this.loading = true;
      allDeptTree()
        .then(rsp => {
          this.fd.allDeptTreeList = rsp.data;
        })
        .catch(err => {
          console.log('初始化机构部门树失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取指定身份权限部门
     * @param {*}
     * @return {*}
     */
    getPermissionDeptTree () {
      this.loading = true;
      permissionDeptTree({ capacityCode: this.dlParams.capacityCode })
        .then(rsp => {
          const permissionDeptTreeListTemp = [];
          for (const s of rsp.data) {
            permissionDeptTreeListTemp.push(s.deptCode);
          }
          this.fd.permissionDeptTreeList = permissionDeptTreeListTemp;
        })
        .catch(err => {
          console.log('获取指定身份权限部门失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存权限部门修改
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      const permission = { capacityCode: this.dlParams.capacityCode, deptList: this.permissionArr };
      savePermission(permission)
        .then(rsp => {
          this.$alert('关联成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.log('保存权限部门修改失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 部门树勾选回调方法
     * @param {*}
     * @return {*}
     */
    handleCheckChange () {
      const res = this.$refs.tree.getCheckedNodes();
      const temp = [];
      res.forEach((item) => {
        temp.push(item.nodeCode);
      });
      this.permissionArr = temp;
    },
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.userVO.userCode = this.dlParams.userCode;
    this.fd.userVO.capacityCode = this.dlParams.capacityCode;
    this.fd.userVO.userName = this.dlParams.userName;
    this.fd.userVO.deptName = this.dlParams.deptName;
  },
  mounted () {
    this.getAllDeptTree();
    this.getPermissionDeptTree();
  }
};
</script>
